import { languageEn } from './en';

export const languages = {
  en: { translations: languageEn }
};

